import AppLayout from "Layout/Layout";
import { NonIndexRouteObject } from "react-router";
import { getResourcePath } from "./constant";
import { ListPage } from "pages/lich-su-thanh-toan/list-page";
import { DetailPage } from "pages/lich-su-thanh-toan/detail-page";
import { EditPage } from "pages/lich-su-thanh-toan/edit-page";
import { CreatePage } from "pages/lich-su-thanh-toan/create-page";

export const lichSuThanhToanRouters: NonIndexRouteObject[] = [
  {
    path: getResourcePath("lich-su-thanh-toan", "list"),
    element: (
      <AppLayout>
        <ListPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("lich-su-thanh-toan", "detail"),
    element: (
      <AppLayout>
        <DetailPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("lich-su-thanh-toan", "edit"),
    element: (
      <AppLayout>
        <EditPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("lich-su-thanh-toan", "create"),
    element: (
      <AppLayout>
        <CreatePage />
      </AppLayout>
    ),
  },
];
